import React, { useState } from 'react'

// custom functions
import ThreeDotIcon from 'assets/icons/three-dot-icon.svg?component'

// styles
import styles from './index.module.scss'
import Link from 'next/link'
import { getDisplayUserName } from 'utils/strings'
import ImageWithFoster from 'components/ImageWithFoster'
import MenuShareCollection from 'components/Menu/MenuShareCollection'
import NFTDescriptionSection from 'components/pages/BrowseNFT/MainSection/NFTDescriptionSection'
import CollectionMenuModal from 'components/Modal/CollectionMenuModal'

const BrowseArtistCard = props => {
  const {
    isOwn,
    image,
    collectionName,
    artistName,
    artistImage,
    artistAddress,
    hasloading,
    setOpenShareModal,
    saveCollection,
    addTokenIds,
    importArtwork,
    onClickEdit,
    description,
    uploadNew,
    saved,
  } = props
  const [showMenuModal, setshowMenuModal] = useState(false)

  return (
    <div>
      <div className="w-full flex justify-between items-start">
        <div className={styles.avatarArea}>
          {hasloading ? (
            <div className={`${styles.skeletonLoader} w-[90px] h-[90px] rounded-[10px] overflow-hidden`}></div>
          ) : (
            <ImageWithFoster src={image} width={90} height={90} className="w-full h-full object-cover rounded-[10px]" />
          )}
        </div>
        <div className="hidden items-center lg:flex">
          <MenuShareCollection
            isOwn={isOwn}
            saved={saved}
            setOpenShareModal={setOpenShareModal}
            saveCollection={saveCollection}
            editCollection={onClickEdit}
            uploadNew={uploadNew}
            importArtwork={importArtwork}
            addTokenIds={addTokenIds}
          />
        </div>

        <div className="lg:hidden cursor-pointer" onClick={() => setshowMenuModal(true)}>
          <ThreeDotIcon />
        </div>
      </div>
      <div className={styles.bottomSection}>
        {hasloading ? (
          <div className={`${styles.skeletonLoader} ${collectionName} w-[240px] h-[36px] rounded-[18px]`}></div>
        ) : collectionName ? (
          <div className={styles.collectionName}>{collectionName}</div>
        ) : (
          <div className="w-full h-[22px]"></div>
        )}

        {hasloading ? (
          <div className="w-full h-[40px] rounded-[20px] overflow-hidden mt-[15px]">
            <div className="skeletonLoader" />
          </div>
        ) : description?.length > 0 ? (
          <div className="w-full mt-[15px]">
            <NFTDescriptionSection description={description} />
          </div>
        ) : null}

        <div className="w-full flex items-center gap-[10px] mt-[15px]">
          {hasloading ? (
            <div className="min-w-[30px] h-[30px] rounded-[15px] overflow-hidden">
              <div className="skeletonLoader" />
            </div>
          ) : (
            <div className="min-w-[30px] h-[30px] rounded-[15px] overflow-hidden">
              <ImageWithFoster
                src={artistImage}
                width={30}
                height={30}
                className="w-full h-full object-cover rounded-[15px]"
              />
            </div>
          )}

          {hasloading ? (
            <div className="min-w-[100px] h-[30px] rounded-[15px] overflow-hidden">
              <div className="skeletonLoader" />
            </div>
          ) : (
            artistName && (
              <div className={styles.artistName}>
                <Link href={`/${artistAddress}`} passHref>
                  <a>{getDisplayUserName(artistName)}</a>
                </Link>
              </div>
            )
          )}
        </div>
      </div>
      {showMenuModal && (
        <CollectionMenuModal
          open={showMenuModal}
          onClose={() => setshowMenuModal(false)}
          isOwn={isOwn}
          saved={saved}
          setOpenShareModal={setOpenShareModal}
          saveCollection={saveCollection}
          editCollection={onClickEdit}
          uploadNew={uploadNew}
          importArtwork={importArtwork}
          addTokenIds={addTokenIds}
        />
      )}
    </div>
  )
}

export default BrowseArtistCard
